module.exports = __webpack_public_path__ + "img/TECNOLOGIA-IGNIS-2021-4.e9f9287a.jpg";